import Grid from '@mui/material/Grid';

import { AllowanceValuesType } from 'components/Allowance/AllowanceDetailForm';
import { TextField } from 'components/TextField';
import { FormikProps } from 'formik';

import { AllowancePaddedPaper as PaddedPaper } from './AllowancePaddedPaper';

const CHARACTER_LIMIT = 40;

export const CreateAllowanceName = ({
  values,
  setFieldValue,
  touched,
  errors
}: FormikProps<AllowanceValuesType>) => {
  return (
    <Grid item sx={{ boxShadow: 'none' }}>
      <PaddedPaper title="Create allowance name *" disabled={!values.editable}>
        <Grid item xs={12}>
          <TextField
            id="name"
            name="name"
            label={
              values.editable
                ? 'Allowance name e.g., “Late Night Credits” '
                : ''
            }
            InputProps={{
              inputProps: { 'data-testid': 'name-input' }
            }}
            onChange={(e) =>
              setFieldValue('name', e.target.value.slice(0, CHARACTER_LIMIT))
            }
            value={values.name}
            helperText={`${values.name.length}/${CHARACTER_LIMIT} characters`}
            fullWidth
            sx={{
              '& .MuiFormHelperText-root': {
                textAlign: 'left',
                marginLeft: 0,
                marginTop: '8px'
              }
            }}
            disabled={!values.editable}
            error={touched.name && Boolean(errors.name)}
          />
        </Grid>
      </PaddedPaper>
    </Grid>
  );
};
